import { startAroundPrefetch } from '@/shared/lib/aroundPrefetch';

import type { RouteLocationNormalized } from 'vue-router';

export const mfRoutes = [
  {
    path: '/around/:slug',
    name: 'around',
    // Хук срабатывает до загрузки чанков страницы: запросы к API идут параллельно со скачиванием JS.
    beforeEnter: (to: RouteLocationNormalized) => {
      startAroundPrefetch(String(to.params.slug ?? ''));
    },
    component: () => import('@/pages/aroundV2/AroundPage.vue'),
  },
];

export default mfRoutes;
